import React, { FC } from 'react';
import {
    FacebookShareButton,
    FacebookIcon,
} from 'react-share';


type Props = {
    title?: string;
    url: string;
    size?: number;
};


export const Facebook: FC<Props> = ({ title, url, size }) => {
    return (
        <FacebookShareButton url={url} quote={title}>
            <FacebookIcon size={size ? size : 56} round />
        </FacebookShareButton>
    );
};